import React from 'react';
import {useNavigate} from 'react-router-dom';
import {useTranslation} from "react-i18next";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ButtonCustom from "@ui/buttons/buttonCustom/ButtonCustom";
import {PATH_MONITORING_SINGLE_VOYAGES} from "@constants/navigate";
import {SxType} from "@baseTypes/sx/sxTypes";

interface IProps {
    fullWidth?: boolean
    sx?: SxType
}

const ReportBackToVoyagesSingleVoyage = ({fullWidth, sx}: IProps) => {

    const {t} = useTranslation()
    const navigate = useNavigate()

    const handleBack = () => {
        navigate(PATH_MONITORING_SINGLE_VOYAGES)
    }

    return (
        <ButtonCustom
            variant={'text'}
            size={'small'}
            fullWidth={fullWidth}
            startIcon={<ArrowBackIcon fontSize={'small'}/>}
            onClick={handleBack}
            sx={sx}
        >
            {t('singleVoyage.reportSheet.backToVoyages')}
        </ButtonCustom>
    );
};

export default ReportBackToVoyagesSingleVoyage;
